import React from 'react';
import { InputNumber, Form } from 'antd';
import PropTypes from 'prop-types';
import './PrntOxido.scss';

const PrnOxidoField = (props) => {
  const {
    rules,
    min,
    max,
    name,
    value,
    edit,
  } = props;

  return (
    <Form.Item
      label={<span className="field-title-text">PRNT do Óxido</span>}
      name={name}
      rules={rules}
      initialValue={value || undefined}
    >
      <InputNumber
        disabled={edit}
        style={{ width: '100%' }}
        {...(min !== null && max !== null ? { min, max } : {})}
      />
    </Form.Item>
  );
};

PrnOxidoField.defaultProps = {};
PrnOxidoField.propTypes = {
  rules: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  name: PropTypes.string.isRequired,
  value: PropTypes.number,
  edit: PropTypes.bool,
};

export default PrnOxidoField;
